import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { DocumentoGerado } from '@/types/agentesIa';

interface DocumentosGeradosResponse {
  success: boolean;
  data: DocumentoGerado[];
}

export function useDocumentosGerados(
  empresaId: number | undefined,
  licitacaoId: number | undefined,
  refreshKey?: string
) {
  return useQuery<DocumentoGerado[]>({
    queryKey: ['redator-ninja-documentos', empresaId, licitacaoId, refreshKey],
    queryFn: async () => {
      const response = await api.get<DocumentosGeradosResponse>(
        `/empresas/${empresaId}/redator-ninja`,
        { params: { licitacaoId } }
      );
      return response.data;
    },
    enabled: Boolean(empresaId && licitacaoId),
  });
}
